import React, { Component } from 'react'
import "./carrierinfo.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { Map, Marker } from 'react-amap';
import { Pagination , Carousel } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { getApiCarrierInfo } from '../../axios/api';
import { UrlSearch } from '../../axios/localstorage';

export default class carrierinfo extends Component {

    state = {
        type:0,
        bType:0,
        content:"      武科技金融园以大数据、云计算、物联网为代表的新一代信息技术产业；以航空航天、高端装备为代表的特色产业以及以新能源、生物医药等为代表的新兴产业已经形成产业集群，重点发展电子信息、生物医药、智能装备、汽车零部件、新材料等主导产业。成为推动高质量发展的创新能极。园区加快特色转型，融入了新一代信息技术发展的时代浪潮。面对高质量发展中遇到的困难挑战，玄武科技金融园敢想敢闯敢试，园区自成立之日起便被赋予了开放包容的精神禀赋，始终保持开放的胸怀，在招商引资、经济运行、基础开发、园区合作、基层管理等方面开发区始终秉承着全心全意为企业服务的理念，全力推进外资、外贸、外包齐头并进，对先进产业、先进技术、先进管理，园区始终突出开放的平台，为企业更好更快发展提供了有力支撑。",
        position:{ 
            longitude:116.314507,
            latitude:39.998272,
        },
        page:1,
        total:51,
        arr:[],
        aIndex:0,
        num:0,
        showSwiper:false,
        slidesPerView:3,
        currentIndex:0,

        timer:"",

        list:[],
        company:[],

        data:{},

        diList:[],
        busList:[],
    }

    componentWillMount(){
        window.scroll(0,0);

        let id = UrlSearch('id');

        getApiCarrierInfo({id})
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                let position = { 
                    longitude:"",
                    latitude:"",
                };

                let location = data.location;

                let larr = location.split(',');

                position = { 
                    longitude:larr[0],
                    latitude:larr[1],
                };

                console.log(position);




                this.setState({
                    arr:data.images,
                    list:data.facilities_arr,
                    company:data.company,
                    data:data,
                    position,
                    diList:data.jiaotong[0].list,
                    busList:data.jiaotong[1].list,
                })

                this.setState({
                    showSwiper:true
                })

            }
        }).catch( err =>{
            console.error(err);
        })

       
    }

    componentDidMount(){
        
    }

    componentWillUnmount(){
        clearInterval(this.state.timer);
    }

    gotoPrevImage=()=>{
        const swiper = document.querySelector('.swiper-container').swiper;

        swiper.slidePrev();

        let num = this.state.currentIndex - 1;
        if(num < 0){
            num = this.state.arr.length - 1;
        }

        this.gotoSlide(num);
    }

    gotoNextImage=()=>{
        const swiper = document.querySelector('.swiper-container').swiper;
        swiper.slideNext()

        let num = this.state.currentIndex + 1;
        if(num > this.state.arr.length){
            num = 0;
        }

        this.gotoSlide(num);
    }



    changePage=(page)=>{
        this.setState({
            page
        })

    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    gotochangeType=(type)=>{
        this.setState({
            type
        })
    }

    gotochangeBusType=(bType)=>{
        this.setState({
            bType
        })
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
        // console.log(index);
        // const swiper = document.querySelector('.swiper-container').swiper;
        // swiper.slideTo(index+this.state.arr.length - 2);
    }

    gotoSlide=(num)=>{
        console.log(num);


        this.refs['bslide'].goTo(num);
    }


    render() {
        return (
            <div className='carrierinfo'>
                <Header type={9} />
                <div className='page'>
                    <div className='pm'>
                        <div className='hname'>
                            <p>当前位置：</p>
                            <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p className='i_point' onClick={()=>{this.gotoPage('/home?end=1')}}>硅巷载体</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p>硅巷载体详情</p>
                        </div>
                        <div className='pbox'>
                            <div className='left'>
                                <div className='imgBox'>
                                    
                                    <div className='imgMain'>

                                        <div className='imgBtn' onClick={()=>{this.gotoPrevImage()}}>
                                            <img alt="" src='/www/assets/imgs/prev.png' />
                                        </div>

                                        <div className='imgBanner'>
                                            
                                            <div className='imgDiv' id="imgBox">

                                                {
                                                    this.state.showSwiper?<Swiper
                                                    simulateTouch={false}
                                                    history = { true}
                                                    slidesPerView = {3}
                                                    direction="vertical"
                                                    spaceBetween = {5}
                                                    loop={true}
                                                    onSlideChange={() => {}}
                                                    onSwiper={(swiper) => {
                                                        let activeIndex = swiper.activeIndex;
                                                       
                                                            // let timer = setInterval(()=>{
                                                            //     this.gotoNextImage();
                                                            // },3000)
                
                                                            // this.setState({
                                                            //     timer
                                                            // })
                                                        
                                                    }}
                                                    >
                                                    {
                                                        this.state.arr.map((item,index)=>{
                                                            return <SwiperSlide key={index} virtualIndex={index}>
                                                                        <div className='ibi' key={index} style={{backgroundImage:"url('"+item+"')"}}>
                                                                        
                                                                        </div>
                                                                    </SwiperSlide>
                                                        })
                                                    }


                                                    </Swiper>:null
                                                }
                                            </div>

                                            {/* <div className='prev'>
                                                <img onClick={()=>{this.gotoPrevImage()}} alt="" src='/www/assets/imgs/prev.png' />
                                            </div>
                                            <div className='next'>
                                                <img onClick={()=>{this.gotoNextImage()}} alt="" src='/www/assets/imgs/next.png' />
                                            </div> */}
                                        </div>

                                        <div className='imgBtn' onClick={()=>{this.gotoNextImage()}}>
                                            <img alt="" src='/www/assets/imgs/next.png' />
                                        </div>
                                    </div>
                                    
                                    <div className='ibg' hidden={!this.state.showSwiper}>
                                        <Carousel ref="bslide" dots={false} draggable={false} afterChange={(index)=>{this.onChange(index)}} autoplay={false} autoplaySpeed={2500}>
                                            {
                                                this.state.arr.map((item,index)=>{
                                                    return <div className='item'>
                                                                <div className="bg"  style={{backgroundImage:"url('"+item+"')"}}></div>
                                                            </div>
                                                            
                                                })
                                            }
                                        </Carousel>
                                    </div>
                                </div>

                                <div className='leftBox'>
                                    <div className='linfo'>
                                        <h2>{this.state.data.title}</h2>
                                        <p>类型等级：{this.state.data.level_text}-{this.state.data.type_text}</p>
                                        <p>详细地址：{this.state.data.address}</p>
                                        <p>官网链接：<span onClick={()=>{window.open(this.state.data.url)}}>{this.state.data.url}</span></p>
                                    </div>
                                    <div className='ptype'>
                                        <div className='pflex'>
                                            <div onClick={()=>{this.gotochangeType(0)}} className={this.state.type === 0?'pfi pf_active':"pfi"} style={this.state.type === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>载体介绍</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div onClick={()=>{this.gotochangeType(1)}} className={this.state.type === 1?'pfi pf_active':"pfi"} style={this.state.type === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>入驻企业</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div onClick={()=>{this.gotochangeType(2)}} className={this.state.type === 2?'pfi pf_active':"pfi"} style={this.state.type === 2?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>优惠政策</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div hidden={this.state.type !== 0}>
                                        {/* <div className='name'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>园区建设背景</h2>
                                        </div>
                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.content
                                        }}></div>

                                        <div className='name'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>主导产业</h2>
                                        </div> */}
                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.data.content
                                        }}></div>
                                    </div>

                                    <div hidden={this.state.type !== 1}>
                                        <div className='name'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>入驻企业</h2>
                                        </div>
                                        <div className='ptable'>
                                            <table>
                                                <tr>
                                                    <th>序号</th>
                                                    <th>企业名称</th>
                                                    <th>创建时间</th>
                                                </tr>
                                                {
                                                    this.state.company.map((item,index)=>{
                                                        return <tr>
                                                                    <td>{index+1}</td>
                                                                    <td>{item.title}</td>
                                                                    <td>{item.setup_time}</td>
                                                                </tr>
                                                    })
                                                }
                                            </table>
                                            <div className='r_page' hidden>
                                                <h4>第 1-17 条/总共 17 条</h4>
                                                <Pagination type="success" size='small' showSizeChanger={false}  pageSize={20}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div hidden={this.state.type !== 2}>
                                        {/* <div className='name'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>优惠政策</h2>
                                        </div>
                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.content
                                        }}></div>

                                        <div className='name'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>申请条件</h2>
                                        </div>
                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.content
                                        }}></div>

                                        <div className='name'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>申报材料</h2>
                                        </div> */}
                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.data.policy
                                        }}></div>
                                    </div>


                                </div>
                            </div>
                            <div className='right'>
                                <div className='rbox'>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                        <h2>配套设施</h2>
                                    </div>
                                    <div className='rsets'>
                                        {
                                            this.state.list.map((item,index)=>{
                                                return <div className='rsi'>
                                                            <div className='rdiv'>
                                                                <div className='cen'>
                                                                    <img alt='' src={item.image} />
                                                                </div>
                                                                <p>{item.title}</p>
                                                            </div>
                                                            <span></span>
                                                        </div>
                                            })
                                        }
                                    </div>
                                </div>

                                <div className='rbox'>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                        <h2>出租价格</h2>
                                    </div>
                                    <div className='rmoney'>
                                        <div className='ritem'>
                                            <h2>日租金：</h2>
                                            <p>{this.state.data.day_money}<span>元/㎡</span></p>
                                        </div>
                                        <div className='ritem'>
                                            <h2>物业管理费：</h2>
                                            <p>{this.state.data.property_money}<span>元/㎡/月</span></p>
                                        </div>
                                        <div className='ritem'>
                                            <h2>建筑面积：</h2>
                                            <p>{this.state.data.area}<span>㎡</span></p>
                                        </div>
                                        <div className='ritem'>
                                            <h2>装修情况：</h2>
                                            <p hidden={this.state.data.decorate !== 0 }>毛胚<span></span></p>
                                            <p hidden={this.state.data.decorate !== 1 }>简装<span></span></p>
                                            <p hidden={this.state.data.decorate !== 2 }>精装<span></span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className='rbox'>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                        <h2>交通配置</h2>
                                    </div>
                                    <div className='rmap'>
                                        <Map amapkey={'42eb15c1f2a44772a9d032729e8ca3f1'} center={this.state.position} zoom={16}>
                                            <Marker position={this.state.position} />
                                        </Map>
                                    </div>
                                    <div className='aname'>
                                        <img alt="" src="/www/assets/imgs/dingwei3.png" />
                                        <p>{this.state.data.address}</p>
                                    </div>
                                    <div className='ptype'>
                                        <div className='pflex'>
                                            <div onClick={()=>{this.gotochangeBusType(0)}} className={this.state.bType === 0?'pfi pf_active':"pfi"}>
                                                <p>地铁</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div onClick={()=>{this.gotochangeBusType(1)}} className={this.state.bType === 1?'pfi pf_active':"pfi"}>
                                                <p>公交</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='rways' hidden={this.state.bType === 1}>
                                        
                                        {
                                            this.state.diList.map((item,index)=>{
                                                return <div className='rwi'>
                                                            <div className='rw_name'>
                                                                <h2>{item.name}</h2>
                                                                <span>距离{item.distance}m</span>
                                                            </div>
                                                            <p>{item.address}</p>
                                                        </div>
                                            })
                                        }
                                    </div>
                                    <div className='rways' hidden={this.state.bType === 0}>
                                        {
                                            this.state.busList.map((item,index)=>{
                                                return <div className='rwi'>
                                                            <div className='rw_name'>
                                                                <h2>{item.name}</h2>
                                                                <span>距离{item.distance}m</span>
                                                            </div>
                                                            <p>{item.address}</p>
                                                        </div>
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
